import React from 'react'
import { classNames } from '../_utils'

import { at } from 'lodash'
import { useField } from 'formik'

export default function TextAreaIcon ( { cols = 5 , rows = 2, required = false, disabled =  false, question = "", name, iconComponent, type =  "text", label, handleChange, handleBlur, value } ) {
  
  const [ field, meta ] = useField( name )

  const _renderText = () => {
    const [ touched, error ] = at( meta, 'touched', 'error' ) 
    if( touched && error )
      return error
    
  }

  return (
    <div className="flex flex-col items-start my-2">
    <div className={ classNames( ( meta.touched && meta.error ) ? "inline-flex w-full rounded-sm border border-red-500" : "inline-flex w-full rounded-sm border border-[#7a9b1e]" ) }>
        <div className="w-1/6 flex items-center justify-center bg-gray-50">
          {iconComponent}
        </div>
        <textarea
          name={name}
          disabled={disabled}
          id={name}
          type={type} 
          placeholder={label}
          onChange={handleChange}
          onBlur={handleBlur}
          value={value}
          autocomplete="off"
          rows={rows}
          cols={cols}
          className={ classNames( ( meta.touched && meta.error ) ? "w-full px-3 py-1 focus:outline-none focus:text-gray-700 placeholder-red-700 text-sm" : "w-full px-3 py-1 focus:outline-none focus:text-gray-700 placeholder-[#7a9b1e] text-sm" ) }>
        </textarea>
    </div>
    
    {(meta.touched && meta.error) ? (
      <p className="text-red-500 py-1" style={{ fontSize: "0.7rem" }}>
        {_renderText()}
    </p>
    ) : (
      <p className="text-blue-900 py-1" style={{ fontSize: "0.7rem" }}>
        {question}{ required && ( <span className="text-red-500">*</span>) }
      </p>
    ) }

  </div>
  )
}
